import { BaseService } from '@literax/services/base-config/base.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceResponse } from '@literax/interfaces/service-response';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TermsService {

  constructor(private base: BaseService) {}

  getTerms(): Observable<ServiceResponse> {
     const path = `/migr/api/${environment.apiVersionMigr}/terms_of_services/latest`;
    return this.base.get(path);
  }

  acceptTerms(
    signRequestId: number,
    documentId: number): Observable<ServiceResponse> {
     const path = `/migr/api/${environment.apiVersionMigr}/documents/${documentId}/signrequests/${signRequestId}/terms_and_conditions/accept`;
    return this.base.post(path, null);
  }
  
}